var _excluded = ["itemToString", "items", "isItemDisabled", "target", "layoutDependency"],
    _excluded2 = ["isOpen", "getItemProps"],
    _excluded3 = ["show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useSelect } from 'downshift';
import { useForwardedRef } from '@adsk/alloy-helpers';
import { useOverlay } from '@adsk/alloy-overlay';
import { defaultLabelGetter } from '../helpers';
import useDisabledItems, { useGetItemProps } from './useDisabledItems';
/**
 * A hook used to manage all logic needed for a Dropdown.
 */

export default (function (_ref) {
  var _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return defaultLabelGetter(item);
  } : _ref$itemToString,
      itemsProp = _ref.items,
      _ref$isItemDisabled = _ref.isItemDisabled,
      isItemDisabled = _ref$isItemDisabled === void 0 ? function (item) {
    return !!item.disabled;
  } : _ref$isItemDisabled,
      target = _ref.target,
      layoutDependency = _ref.layoutDependency,
      props = _objectWithoutProperties(_ref, _excluded);

  var targetRef = useForwardedRef(target || null);

  var _useDisabledItems = useDisabledItems({
    items: itemsProp,
    isItemDisabled: isItemDisabled
  }),
      items = _useDisabledItems.items;

  var _useSelect = useSelect(_objectSpread({
    itemToString: itemToString,
    items: items
  }, props)),
      downshiftIsMenuOpen = _useSelect.isOpen,
      getItemProps = _useSelect.getItemProps,
      useComboboxReturnValue = _objectWithoutProperties(_useSelect, _excluded2);

  var _useOverlay = useOverlay(_objectSpread({
    placement: 'bottom-start',
    show: downshiftIsMenuOpen,
    target: targetRef,
    layoutDependency: "".concat(items.length).concat(layoutDependency)
  }, props)),
      useOverlayIsOpen = _useOverlay.show,
      useOverlayReturnValue = _objectWithoutProperties(_useOverlay, _excluded3);

  return _objectSpread(_objectSpread({
    isOpen: useOverlayIsOpen,
    menuItems: items,
    getItemProps: useGetItemProps({
      getItemProps: getItemProps
    })
  }, useComboboxReturnValue), useOverlayReturnValue);
});
//# sourceMappingURL=useDropdown.js.map